import Axios from "axios";
import {
    SET_HRM_EMPLOYEE_KPI_LIST,
    UNSET_HRM_EMPLOYEE_KPI_LIST,
  } from "@/store/mutation-types";
import { 
  getHrmEmployeeKpisList,
  saveHrmEmployeeKpi,
  updateHrmEmployeeKpi,
  getHrmEmployeeKpiById
} from "@/store/api";

const state = {
  getHrmEmployeeKpisList: [],
};

const getters = {
  getHrmEmployeeKpisList(state) {
    return state.getHrmEmployeeKpisList;
  },
};

const mutations = {
  [SET_HRM_EMPLOYEE_KPI_LIST](state, data) {
    state.getHrmEmployeeKpisList = data;
  },
  [UNSET_HRM_EMPLOYEE_KPI_LIST](state) {
    state.getHrmEmployeeKpisList = [];
  },
};

const actions = {

  saveHrmEmployeeKpi({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveHrmEmployeeKpi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  updateHrmEmployeeKpi({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    const invCustomerKpi = `${updateHrmEmployeeKpi}/${data.employee_kpi_id}`
    return new Promise((resolve, reject) => {
      Axios.put(invCustomerKpi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getHrmEmployeeKpisList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmEmployeeKpisList, {params:data})
        .then(function (response) {
          commit('SET_HRM_EMPLOYEE_KPI_LIST', response.data.data)
          resolve(response.data.data);
        })
        .catch(function (error) {
          commit('UNSET_HRM_EMPLOYEE_KPI_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getHrmEmployeeKpiById({ commit }, data) {
    const getInvCustomerKpi = `${getHrmEmployeeKpiById}/${data}`;
    commit("SET_LOADING", {color: "primary"});  
    return new Promise((resolve, reject) => {
      Axios.get(getInvCustomerKpi)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },  
};

export default {
  state,
  getters,
  actions,
  mutations,
};
